export default __webpack_public_path__ + "static/media/whale.928c942f.svg";